import { Chip, ChipProps } from '@mui/material'
import React, { FC } from 'react';

const ChipWrapper: FC<ChipProps> = ({...props}) => <Chip {...props}/>

export default ChipWrapper;
